import initialProductState from "../product.initialState";
import { reduxActions as PRODUCT } from "_constants/product.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const get = {
  [PRODUCT.GET_STARTED]: (state) => ({
    ...state,
    get: {
      data: null,
      error: null,
      status: LOADING
    }
  }),
  [PRODUCT.GET_SUCCESS]: (state, { payload }) =>  ({
    ...state,
    get: {
      status: SUCCESS,
      data: payload?.data?.[0] ?? null,
      error: null
    }
  }),
  [PRODUCT.GET_FAIL]: (state, { payload }) => ({
    ...state,
    get: {
      status: FAILURE,
      data: null,
      error: payload?.data?.status?.[0]?.desc
    }
  }),
  [PRODUCT.GET_RESET]: (state) =>  ({
    ...state,
    get: initialProductState.get
  })
};

export default get;
